import { React, Component, Container, Route, Link, _ } from 'utils';
import { withRouter, Switch } from 'react-router-dom';
import { WhyStore, Creators, SelectedPavilionStore, App } from 'model';
import './whyus.less';
import Swiper, { Slide } from './swiper';

class WhyUs extends Component {

	static getStores() {
		return [WhyStore, SelectedPavilionStore];
	}

	static calculateState(state, props) {
		var { pavilion, stand } = props.match.params;

		var standId = WhyStore.getStandId();
		var data = WhyStore.getData();

		return { pavilion, stand, standId, data }
	}
	
	componentWillMount() {
		var { pavilion, stand } = this.props.match.params;
		Creators.loadWhy(pavilion, stand);
	}

	componentDidUpdate() {
		var standId = WhyStore.getStandId();
		var data = WhyStore.getData();

		if(standId != null && data == null) {
			Creators.loadWhyUs(standId);
		}
	}

	componentWillUnmount() {
		Creators.loadWhy(null, null);
	}

	render() {
		var pavilion = WhyStore.getPavilion();
		var stand = WhyStore.getStand();
		var url = `/pavilion/${pavilion}/stand/${stand}/why`;

		var benefits = {
			title: _('Benefits'),
			css: 'benefits',
			items: WhyStore.getBenefits()
		}

		var perks = {
			title: _('Perks'),
			css: 'perks',
			items: WhyStore.getPerks()
		}

		var testimonials = {
			title: _('Testimonials'),
			items: WhyStore.getTestimonials()
		}

		return <Switch>
			<Route path="/pavilion/:pavilion/stand/:stand/why/testimonials" render={ () => <WhyTestimonials data={ testimonials } /> } />;
			<Route path="/pavilion/:pavilion/stand/:stand/why/benefits" render={ () => <WhyIcons data={ benefits } /> } />;
			<Route path="/pavilion/:pavilion/stand/:stand/why/perks" render={ () => <WhyIcons data={ perks } /> } />;
			<Route path="/pavilion/:pavilion/stand/:stand/why" render={ () => <Why url={url} /> } />;
		</Switch>;
	}
}

function Why({ url }) {

	return <div className="col-md-12">
		<h1 className="display-4">{ _('Why Us')}</h1>
			<div className="icons">
				<div className="row">
					<Benefits baseUrl={ url } />
					<Perks baseUrl={ url } />
					<Testimonials  baseUrl={ url } />
				</div>
		</div>
	</div>
}

function WhyTestimonials({ data }) {

	var { title, items } = data;

	return <div className="col-md-12">
		<h1 className="display-4">{ title }</h1>
		<Swiper items={ data.items } slide={(item) => <Slide item={item} /> } />
	</div>
}

function WhyIcons({ data }) {
	var { title, items, css } = data;

	var icons = items.map((item) => {
		return <div key={item.id} className="col-xs-12 col-sm-6 col-md-4">
			<div className="icon">
				<img src={ item.imageUrl } />
				<div className="description"><div>{ _(item.name)}</div></div>
			</div>
		</div>;
	});

	if(items.length > 0) {
		return <div className="col-12">
			<div className={ css }>
				<h1 className="display-4">{ title }</h1>
				<div className="icons">
					<div className="row">{ icons }</div>
				</div>
			</div>
		</div>;
	} else {
		return null;
	}
}

function Benefits({ baseUrl }) {
	if(WhyStore.getBenefits().length > 0) {
		var url = App.resourceUrl('whyus/benefits.svg');

		return <div className="col-xs-12 col-sm-6 col-md-4">
			<Link to={ `${baseUrl}/benefits` }>
				<span className="icon">
					<img src={url} />
					<span className="description">
						<span>{_('Benefits')}</span>
					</span>
				</span>
			</Link>
		</div>
	} else {
		return null;
	}
}

function Perks({ baseUrl }) {
	if(WhyStore.getPerks().length > 0) {
		var url = App.resourceUrl('whyus/perks.svg');

		return <div className="col-xs-12 col-sm-6 col-md-4">
			<Link to={ `${baseUrl}/perks` }>
				<span className="icon">
					<img src={url} />
					<span className="description">
						<span>{_('Perks')}</span>
					</span>
				</span>
			</Link>
		</div>;
	} else {
		return null;
	}
}

function Testimonials({ baseUrl }) {

	if(WhyStore.getTestimonials().length > 0) {
		var url = App.resourceUrl('whyus/testimonials.svg');

		return <div className="col-xs-12 col-sm-6 col-md-4">
			<Link to={ `${baseUrl}/testimonials` }>
				<span className="icon">
					<img src={url} />
					<span className="description">
						<span>{_('Testimonials')}</span>
					</span>
				</span>
			</Link>
		</div>;
	} else {
		return null;
	}
}

export default withRouter(Container.create(WhyUs, { withProps: true }));


// WEBPACK FOOTER //
// ./src/modules/components/activities/whyus.js